module.exports = __webpack_public_path__ + "img/user-guide-02-02-02.4545a183.png";